import { useCheckIfValueExistsInDisplayOptions } from './useCheckIfValueExistsInDisplayOptions';
import { DisplayOption } from '~/types/DisplayOptions';

interface IComponentNamesData {
  standard: () => Promise<any>;
  [key: string]: () => Promise<any>;
}

export const useGetComponentName = (data: IComponentNamesData, displayOptions: DisplayOption[]) => {
  let componentName;
  for (const key of Object.keys(data)) {
    if (componentName) break;
    if (useCheckIfValueExistsInDisplayOptions(key, displayOptions)) {
      componentName = data[key];
    }
  }
  return componentName ? componentName : data.standard;
};
